import { TravelDirection, type Locale } from '@/shared/types/common.types'
import { formatDateDefault } from '@/shared/utils'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export interface TravelerOption {
  srNo: string
  dateOfBirth: Date | string
  nationalityName: string
  passportNo: string
  relationName?: string
  email?: string
  phone?: string
  gender?: string
  emirateId?: string
  civilIdExpiryDate?: Date | string
  withWinterSport?: boolean
}

export const useGetInsuredTravelerOptions = () => {
  const { t, locale } = useI18n()
  const _locale = computed(() => locale.value as Locale)

  const getInsuredTravelerOptions = (
    traveler: TravelerOption,
    typeOfTravel: TravelDirection,
    isQuote: boolean
  ) => {
    let options: { title: string; value: string }[] = []
    if (!traveler) return options

    const checkGender = (gender?: string) => {
      if (gender && gender === '1') {
        return t('outbound.travelers.gender.male')
      } else if (gender && gender === '2') {
        return t('outbound.travelers.gender.female')
      } else {
        return gender || ''
      }
    }

    options = [
      ...(traveler.srNo !== 'holder' && !isQuote
        ? [
            {
              title: t('inbound_travelers_add_relationship'),
              value: traveler.relationName ?? '',
            },
          ]
        : []),
      {
        title: t('inbound_dob_date'),
        value: formatDateDefault(traveler.dateOfBirth, _locale.value),
      },
      ...(traveler.srNo === 'holder'
        ? [
            {
              title: t('outbound.travelers.gender.label'),
              value: checkGender(traveler.gender),
            },
          ]
        : []),
      ...(typeOfTravel === TravelDirection.OUTBOUND && traveler.srNo === 'holder'
        ? [
            {
              title: t('outbound.travelers.qatar_id'),
              value: traveler.emirateId ?? '',
            },
            {
              title: t('outbound.personal_info.qid_exp_date'),
              value: traveler.civilIdExpiryDate
                ? formatDateDefault(traveler.civilIdExpiryDate, _locale.value)
                : '',
            },
          ]
        : []),
      {
        title: t('inbound_nationality_nationality'),
        value: traveler.nationalityName ?? '',
      },
      {
        title: t('inbound_id_number'),
        value: traveler.passportNo ?? '',
      },

      ...(traveler.srNo === 'holder'
        ? [
            {
              title: t('inbound_travelers_add_email'),
              value: traveler.email ?? '',
            },
            {
              title: t('inbound_travelers_add_mobile_number'),
              value: traveler.phone ?? '',
            },
          ]
        : []),
    ]

    return options
  }

  return {
    getInsuredTravelerOptions,
  }
}
